import React, { useContext, useState } from 'react';
import useQueries from '../../../database/useQueries';
import { useLocation, useNavigate } from 'react-router-dom';
import useQueryGraves from '../../../database/filters/queriesGrave';
import { DataContext, TemplateContext } from '../pagesMains/GravesManagers/Graves';
import { useSelector } from 'react-redux';
import { mapFieldValues, onClickRow } from '../plagins/utility';
import { GlobalContext } from '../../../App';
import { useEffect } from 'react';
import PaymentsManagementExample from '../../template/tableV2/PaymentsManagementExample';
import useFilteredData from '../../template/tableV2/FilterFunction';
import { createFetchDataServer, getTableData } from '../../../database/fetchData';

// פונקציה לחשב רוחב קומפוננטה מותאם
const calculateDynamicWidth = () => {
  const screenWidth = window.innerWidth; // רוחב המסך
  let componentWidth;

  if (screenWidth >= 1200) {
    // מסך מחשב
    componentWidth = screenWidth * 0.8; // 80%
  } else if (screenWidth >= 768) {
    // מסך טאבלט
    componentWidth = screenWidth * 0.95; // 95%
  } else {
    // מסך פלאפון
    componentWidth = screenWidth; // 100%
  }

  return Math.round(componentWidth);
};

const AreaGraveHome = () => {
  // קבלת ערכים מהסטור
  const optionsFields = useSelector((state) => state.dataOptionsFieldsHe.data);
  const columns = useSelector((state) => state.columnsTableAreaGraves.data);

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);

  // טעינת היוזים לפונקציות עזר
  const { getSummaryByAreaGrave } = useQueryGraves();

  const [loading, setLoading] = useState(true); // מצב טעינה
  const [rowsPerPage, setRowsPerPage] = useState(25); // מספר רשומות להצגה בעמוד
  const [currentPage, setCurrentPage] = useState(1); // עמוד נוכחי
  // ערכי הראוטר
  const navigate = useNavigate();
  const location = useLocation();

  const { searchText, setTotalWidthContainer } = useContext(TemplateContext);
  const { token, setBreadcrumbs, setTitle } = useContext(GlobalContext);

  useEffect(() => {
    const width = calculateDynamicWidth();
    setTotalWidthContainer(width);

    // עדכון רוחב הקומפוננטה אם גודל המסך משתנה
    const handleResize = () => {
      const newWidth = calculateDynamicWidth();
      setTotalWidthContainer(newWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [location.pathname]);

  useEffect(() => {
    // בדיקה אם הכתובת מסתיימת ב-'globalSearch'
    if (location.pathname.endsWith('globalSearch')) {
      setBreadcrumbs([]);
      setTitle(`חיפוש כללי`);
    } else {
      setBreadcrumbs([{ id: 0, name: 'אחוזות קברים', url: '/areaGrave' }]);
      setTitle(`אחוזות קבר`);
    }
  }, [location.pathname]);

  const mappedData = mapFieldValues(context?.contextAreaGraves, optionsFields);

  // שימוש בפונקציה החיצונית לסינון הנתונים
  const filteredData = useFilteredData(mappedData, searchText);

  const handleRowClick = (row) => {
    if (location.pathname.endsWith('globalSearch')) {
      navigate('/areaGrave'); // משנה את הניווט לנתיב '/block'
    }

    // לאחר מכן מפעיל את הפונקציה onClickRow עם הניווט המקורי
    onClickRow(row, getSummaryByAreaGrave, navigate);
  };

  useEffect(() => {
    async function loadTableData() {
      const localTempData = await getTableData('myDatabase', 'myStore');
      if (localTempData) {
        const dataAreaGraves = localTempData.find((item) => item.name === 'dataAreaGraves');
        const dataGraves = localTempData.find((item) => item.name === 'dataGraves');
        if (dataAreaGraves && dataGraves) {
          setLoading(false);
        }
      }
      const handlePartialUpdate = (tableName) => {
        console.log(`Partial update received for table: ${tableName}`);
        setLoading(false);
      };
      // fetchDataServerWithCallback(['areaGraves'], token, handlePartialUpdate);

      fetchDataServer(['graves'], token);
    }
    loadTableData();
  }, []);

  return (
    <>
      <PaymentsManagementExample columns={columns.filter((prop) => prop.show)} defaultRows={filteredData} searchText={filteredData} onRowSelect={handleRowClick} currentPage={currentPage} rowsPerPage={rowsPerPage} />
      <p>
        Location: <span style={{ fontFamily: "'Courier New', Courier, monospace" }}>/AreaGraveHome</span>
      </p>
    </>
  );
};

export default AreaGraveHome;
